/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * The loader components
 *
 * @author Anton Panasenko
 * @version 1.3.0
 * @since 1.3.0
 */

import { LoaderLinearItemContainerStyled, LoaderLinearItemLineStyled } from './styled/LoadersStyled';

interface ILoaderLinearProps {
    maxWidth?: string;
}

export const LoaderLinear = (props: ILoaderLinearProps) => (
    <LoaderLinearItemContainerStyled maxWidth={props.maxWidth}>
        <LoaderLinearItemLineStyled />
    </LoaderLinearItemContainerStyled>
);
